import { clsx } from 'clsx';

export const baseClasses = clsx(
  'anim-effect focus-within:focus-outline text-body relative z-10 flex items-center gap-xxs rounded-s border bg-main outline-none hover:outline hover:outline-3 hover:outline-offset-0 hover:outline-hover hover:ring-strong',
);

export const normalBorder = clsx('border-1 border-main');

export const errorBorder = clsx('border-none ring-2 ring-inset ring-error');

export const sizeClasses = {
  default: clsx('h-clickable px-xs'),
  small: clsx('h-clickable-minimum px-xxs'),
};
